export enum EObjectTypeActions {
  setObjectType = 'objectType/setObjectType',
}
